// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.1.10_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.1_f4893ebf28ed7f924e57e0016ea700de/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.1.10_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.1_f4893ebf28ed7f924e57e0016ea700de/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.1.10_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.1_f4893ebf28ed7f924e57e0016ea700de/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].oneOf[0].use[1]!./base.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MaLmiTCQn4QMQHd6 {
  border-radius: var(--lp-border-radius-medium);
  border-style: solid;
  border-width: var(--lp-border-width-200);
  color: var(--lp-color-text-ui-primary-base);
  font: var(--lp-text-body-2-regular);
  min-width: 0;
  padding: 5px var(--lp-spacing-300);
  flex: 1;
}

.MaLmiTCQn4QMQHd6:is([data-focused], [data-focus-within]) {
  outline: 2px solid var(--lp-color-shadow-interactive-focus);
  outline-offset: -2px;
  z-index: 1;
}

.MaLmiTCQn4QMQHd6[data-disabled] {
  background-color: var(--lp-color-bg-field-disabled);
  border-color: var(--lp-color-bg-field-disabled);
  color: var(--lp-color-text-field-disabled);
}

.MaLmiTCQn4QMQHd6[data-invalid] {
  border-color: var(--lp-color-border-field-error);
}

.MaLmiTCQn4QMQHd6::placeholder {
  color: var(--lp-color-text-field-placeholder);
}

.clnbDLk7QTsGVXYZ {
  flex: 1;
  min-width: 0;
  display: flex;
  position: relative;
}

.clnbDLk7QTsGVXYZ:has( > [data-validation-icon]) > input {
  padding-inline-end: var(--lp-spacing-700);
}

.Q2F4Fm8ZU6PRhi9G {
  z-index: 2;
  fill: var(--lp-color-fill-feedback-success);
  pointer-events: none;
  inset-inline-end: var(--lp-spacing-300);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.AcxGLpXu7b0c3eFD {
  background-color: var(--lp-color-bg-field-base);
  border-color: var(--lp-color-border-field-base);
}

.yFpJBOMXadwuDUws {
  background-color: inherit;
  margin-left: calc(var(--lp-spacing-300)*-1 - 1px);
}

.yFpJBOMXadwuDUws:not([data-invalid]) {
  border-color: #0000;
}

.yFpJBOMXadwuDUws[data-hovered]:not([data-focused]):not([data-focus-within]) {
  background-color: var(--lp-color-bg-interactive-secondary-hover);
}
`, "",{"version":3,"sources":["webpack://./../../launchpad-ui/packages/components/src/styles/Input.module.css"],"names":[],"mappings":"AAAA;EAEE,6CAA6C;EAC7C,mBAAmB;EACnB,wCAAwC;EACxC,2CAA2C;EAC3C,mCAAmC;EACnC,YAAY;EACZ,kCAAkC;EAClC,OAAO;AACT;;AAEA;EACE,2DAA2D;EAC3D,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,mDAAmD;EACnD,+CAA+C;EAC/C,0CAA0C;AAC5C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,6CAA6C;AAC/C;;AAMA;EAHE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAMA;EAHE,yCAAyC;AAC3C;;AAMA;EAHE,UAAU;EACV,2CAA2C;EAC3C,oBAAoB;EACpB,uCAAuC;EACvC,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;;AAMA;EAHE,+CAA+C;EAC/C,+CAA+C;AACjD;;AAMA;EAHE,yBAAyB;EACzB,iDAAiD;AACnD;;AAMA;EAHE,mBAAmB;AACrB;;AAMA;EAHE,gEAAgE;AAClE","sourcesContent":[".base {\n  composes: field from \"./base.module.css\";\n  border-radius: var(--lp-border-radius-medium);\n  border-style: solid;\n  border-width: var(--lp-border-width-200);\n  color: var(--lp-color-text-ui-primary-base);\n  font: var(--lp-text-body-2-regular);\n  min-width: 0;\n  padding: 5px var(--lp-spacing-300);\n  flex: 1;\n}\n\n.base:is([data-focused], [data-focus-within]) {\n  outline: 2px solid var(--lp-color-shadow-interactive-focus);\n  outline-offset: -2px;\n  z-index: 1;\n}\n\n.base[data-disabled] {\n  background-color: var(--lp-color-bg-field-disabled);\n  border-color: var(--lp-color-bg-field-disabled);\n  color: var(--lp-color-text-field-disabled);\n}\n\n.base[data-invalid] {\n  border-color: var(--lp-color-border-field-error);\n}\n\n.base::-moz-placeholder {\n  color: var(--lp-color-text-field-placeholder);\n}\n\n.base::placeholder {\n  color: var(--lp-color-text-field-placeholder);\n}\n\n.validInput {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  position: relative;\n}\n\n.validInput:has( > [data-validation-icon]) > input {\n  padding-inline-end: var(--lp-spacing-700);\n}\n\n.validIcon {\n  inset-inline-end: var(--lp-spacing-300);\n  z-index: 2;\n  fill: var(--lp-color-fill-feedback-success);\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n._default {\n  background-color: var(--lp-color-bg-field-base);\n  border-color: var(--lp-color-border-field-base);\n}\n\n.minimal {\n  background-color: inherit;\n  margin-left: calc(var(--lp-spacing-300)*-1 - 1px);\n}\n\n.minimal:not([data-invalid]) {\n  border-color: #0000;\n}\n\n.minimal[data-hovered]:not([data-focused]):not([data-focus-within]) {\n  background-color: var(--lp-color-bg-interactive-secondary-hover);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": `MaLmiTCQn4QMQHd6 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["field"]}`,
	"validInput": `clnbDLk7QTsGVXYZ`,
	"validIcon": `Q2F4Fm8ZU6PRhi9G`,
	"_default": `AcxGLpXu7b0c3eFD`,
	"minimal": `yFpJBOMXadwuDUws`
};
export default ___CSS_LOADER_EXPORT___;
